import { findFscSeatAtLimit, getFscNextTier, isFscOpsSeat } from './fscCatalogHelpers';
export function buildFscSeatsBannerConfig({
  catalog,
  tier,
  seatTypes,
  isOpsBannerVisible
}) {
  const seatAtLimit = findFscSeatAtLimit(seatTypes);
  if ((seatAtLimit === null || seatAtLimit === void 0 ? void 0 : seatAtLimit.stepper.max) !== undefined) {
    return {
      type: 'seatLimitReached',
      seatApiName: seatAtLimit.seatTypeId,
      currentTier: tier,
      maxQuantity: seatAtLimit.stepper.max,
      upgradeTier: getFscNextTier(catalog, tier)
    };
  }
  const hasOpsSeats = seatTypes.some(seat => !seat.isPrimary && seat.stepper.quantity > 0 && isFscOpsSeat(catalog, seat.seatTypeId));
  if (isOpsBannerVisible && hasOpsSeats) {
    return {
      type: 'opsSeatDependency'
    };
  }
  return {
    type: 'none'
  };
}
export function getFscSeatsBannerTrackingName(config) {
  switch (config.type) {
    case 'seatLimitReached':
      return `${config.seatApiName}-seat-limit`;
    case 'opsSeatDependency':
      return 'ops-seat-dependency';
    case 'none':
      return undefined;
    // no default
  }
}